import React from 'react';
import PropTypes from 'prop-types';
import Select from '../Select';
import { fetchTimeZones } from '../../../actions/catalogs/apiRequests';

class TimeZonesDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      defaultTz: 'Europe/London',
      options: []
    };
  }

  componentDidMount() {
    fetchTimeZones()
      .then(timeZones => this.setState({
        options: timeZones.map(tz => ({
          value: tz.id,
          label: `${tz.abbr} ${tz.displayName} ${tz.baseUtcOffset}`
        })),
        isLoading: false
      }))
      .catch((this.setState({ isLoading: false })));
  }

  render() {
    const { options, isLoading, defaultTz } = this.state;
    const { value, onChange } = this.props;
    const userTzExists = options.findIndex(opt => opt.value === value) !== -1;

    return (
      <Select
        isLoading={isLoading}
        disabled={isLoading}
        value={userTzExists ? value : defaultTz}
        onChange={onChange}
        options={options}
      />
    );
  }
}

TimeZonesDropdown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default TimeZonesDropdown;


// WEBPACK FOOTER //
// src/components/shared/TimeZonesDropdown/index.jsx